import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static values = {
    isOpened: { type: Boolean, default: false }
  }

  static targets = ['sidebar']

  connect () {
    useClickOutside(this, { element: this.sidebarTarget })
  }

  isOpenedValueChanged (value) {
    if (value === true) {
      this.sidebarTarget.classList.add('sidebar-opened')
      this.#toggleBackdrop()
    } else {
      this.sidebarTarget.classList.remove('sidebar-opened')
      this.#toggleBackdrop()
    }
  }

  open () {
    this.isOpenedValue = true
  }

  close () {
    this.isOpenedValue = false
  }

  clickOutside (event) {
    if (this.isOpenedValue) {
      event.preventDefault()
      this.isOpenedValue = false
    }
  }

  #toggleBackdrop () {
    const container = document.querySelector('.body')
    let backdrop = container.querySelector('.backdrop')

    if (this.isOpenedValue) {
      if (!backdrop) {
        setTimeout(() => {
          backdrop = document.createElement('div')
          backdrop.classList.add('backdrop')
          container.appendChild(backdrop)
        }, 150)
      }
    } else {
      if (backdrop) {
        container.removeChild(backdrop)
      }
    }
  }
}
